import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {UpdateArchivableParams} from 'app-core/platform/archivable/CoreObjectArchiveConstants';
import {patchJSONPromise, postJSONPromise} from 'util/Net';

export interface CreateDatasetParams {
  name: string;
}

export interface CreateDatasetResponse {
  createdIds: Array<string>;
}

export function createDataset(dataset: CreateDatasetParams): Promise<CreateDatasetResponse> {
  const creates = [dataset];
  return postJSONPromise({url: getApiBaseForObjectType(DomainGraphType.DATASET), data: {creates}});
}

export interface UpdateDatasetParams extends UpdateArchivableParams {
  id: string;
  name?: string;
}

export interface UpdateDatasetResponse {
  updatedIds: Array<string>;
}

export function updateDataset(dataset: UpdateDatasetParams): Promise<UpdateDatasetResponse> {
  const updates = [dataset];
  return patchJSONPromise({url: getApiBaseForObjectType(DomainGraphType.DATASET), data: {updates}});
}
